/* One entrance for every menu and modal: fade plus a small vertical shift on
   a short ease-out tween — no scale, no spring. Scaling a text layer makes
   the browser re-rasterise it when the animation ends, which read as a
   one-time flicker (review round 2, item 2; the template shows it too), and
   the spring's overshoot added to it. Menus drop from their trigger
   (negative y), modals and toasts rise (positive y). */
const EASE = [0.16, 1, 0.3, 1];

export function enter(y = 8) {
  return {
    initial: { opacity: 0, y },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: Math.round(y / 2) },
    transition: { duration: 0.15, ease: EASE },
  };
}

/* Every modal backdrop: the dim and the blur of the page behind it fade in
   together. The backdrops used to fade their opacity while carrying a
   backdrop blur, which Chrome draws in a different way once an opacity fade
   ends, and the dialogs flickered as they opened (reports 2026-10-05 and
   2026-10-07, six dialogs). Fading the colour and the blur radius instead
   keeps the layer the same from the first frame to the last. `dim` is the
   black's final alpha. */
export function backdrop(dim = 0.5) {
  const hidden = { backgroundColor: "rgba(0, 0, 0, 0)", backdropFilter: "blur(0px)" };
  return {
    initial: hidden,
    animate: { backgroundColor: `rgba(0, 0, 0, ${dim})`, backdropFilter: "blur(8px)" },
    exit: hidden,
    transition: { duration: 0.15, ease: EASE },
  };
}
